export var switchTheme = {
  baseStyle: {
    container: {
      display: 'inline-flex',
      alignItems: 'center',
      columnGap: 'xs'
    },
    switch: {
      position: 'relative',
      input: {
        cursor: 'pointer',
        appearance: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 'full',
        backgroundColor: 'neutral.dark',
        transition: 'background-color .2s',
        _checked: {
          backgroundColor: 'brand.main',
          _disabled: {
            backgroundColor: 'brand.lighter'
          }
        },
        _disabled: {
          cursor: 'not-allowed',
          backgroundColor: 'neutral.light'
        }
      }
    },
    slider: {
      content: '""',
      cursor: 'pointer',
      position: 'absolute',
      top: '2px',
      left: '2px',
      borderRadius: 'full',
      transition: '0.2s',
      backgroundColor: 'neutral.white',
      _checked: {
        left: 'calc(100% - 2px)',
        transform: 'translate(-100%)'
      },
      _disabled: {
        cursor: 'not-allowed',
        backgroundColor: 'neutral.white'
      }
    },
    label: {
      textStyle: 'body2',
      cursor: 'pointer',
      color: 'neutral.black',
      _disabled: {
        cursor: 'not-allowed',
        color: 'neutral.light'
      }
    }
  },
  sizes: {
    large: {
      switch: {
        input: {
          width: '36px',
          height: '20px'
        }
      },
      slider: {
        width: '16px',
        height: '16px'
      }
    },
    small: {
      switch: {
        input: {
          width: '28px',
          height: '16px'
        }
      },
      slider: {
        width: '12px',
        height: '12px'
      }
    }
  },
  defaultProps: {
    size: 'large'
  }
};
//# sourceMappingURL=Switch.theme.js.map